import React from 'react'
import Skeleton from 'react-loading-skeleton'

function SkeletonKpi({ size }){
    return <div className={`card border-0 text-truncate mb-3`}>
        <div className="card-body">
            <div className="row d-flex justify-content-between" style={{height:"30px"}}>
                <div className="col-sm-6 col mb-1 f-s-16">
                    <b className="mb-3"><Skeleton height={20} width="100%" /></b> 
                    <span className="ml-2" >
                    </span>
                </div>
            </div>
            <div className="d-flex align-items-center mb-1">
                <h1 className={`mb-0 font-weight-bold`}>
                    <Skeleton width="200px" style={{maxWidth: "100%"}} />
                </h1>
                <div className="ml-auto">
                    <Skeleton width="100%" />
                </div>
            </div>
            {size === "normal" && <>
                <hr className="bg-grey" />
                <div className="text-truncate">
                    <Skeleton width="100%" count={3} />
                </div>
            </>}
        </div>
    </div>
}

SkeletonKpi.defaultProps = {
    size: "normal"
}

export default SkeletonKpi